import styled from "styled-components";

export default styled.div`
  flex-shrink: 0;
  height: 100%;
  width: 100%;
  color: var(--section-dark-tint-color, var(--dark-tint));
  .setting-wrapper {
    padding: 20px 32px;
    box-sizing: border-box;
  }
  .field,
  .select-box {
    min-width: 264px;
    max-width: 100%;
  }

  .toggle-field {
    .field {
      margin: 0;
    }
  }
  .delete {
    float: right;
    cursor: pointer;
    line-height: 35px;
  }
  .description {
    color: var(--section-ebony-light-color, var(--ebony-light));
    font-size: 15px;
    margin: 0 0 24px 0;
  }
  .activate-description {
    margin: 0 0 40px 0;
  }
  .status_active_description {
    margin: 0 0 18px 0;
  }
  @media (min-width: 1260px) {
    .inline-fields {
      display: flex;
      .field .field {
        margin-bottom: 0;
      }
      .field + .field {
        margin-left: 24px;
      }
    }
  }
`;
